import { axiosGet } from '../../axios/axios.js'

const PASSWORD_REQUIREMENTS_SERVICE = '/service/user/passwordrequirements'

export function getPasswordConfiguration () {
  return axiosGet({
    url: PASSWORD_REQUIREMENTS_SERVICE,
    onSuccess: (response) => {
      return response.data.result
    }
  })
}

function isCharacterALetter (char) {
  return char.toLowerCase() !== char.toUpperCase()
}

export async function getEmployeePasswordRequirements (user, config = null) {
  let requirementsConfig = config
  if (!requirementsConfig) {
    requirementsConfig = await getPasswordConfiguration()
  }
  return (value, valueInitial = null) => {
    if (value && value !== valueInitial) {
      if (requirementsConfig.minLength && value.length < requirementsConfig.minLength) {
        return `Длина пароля должна быть не менее ${requirementsConfig.minLength} символов`
      }
      if (user && user.key && user.key.toLowerCase() === value.toLowerCase()) {
        return 'Пароль не должен равняться логину'
      }
      let numbersCount = 0
      let lettersCount = 0
      for (let i = 0; i < value.length; i++) {
        const c = value.charAt(i)
        if (isCharacterALetter(c)) {
          lettersCount++
        } else if (!isNaN(c)) {
          numbersCount++
        }
      }
      if (numbersCount < requirementsConfig.minDigitsCount) {
        return 'Минимальное число цифр - ' + requirementsConfig.minDigitsCount
      } else if (lettersCount < requirementsConfig.minLettersCount) {
        return 'Минимальное число букв - ' + requirementsConfig.minLettersCount
      }
      if (requirementsConfig.lowerAndUpperCasesRequired && (value === value.toLowerCase() || value === value.toUpperCase())) {
        return 'Пароль должен содержать верхний и нижний регистр'
      }
      // TODO minOtherCount
    }
    return true
  }
}
